const tabsChecklistQuestions = {
  TabLabel1: 'DETALLE DE LA PREGUNTA',
  TabLabel2: 'IMAGEN DESCRIPTIVA',
  TabLabel3: 'OTRAS OPCIONES',
};

export default tabsChecklistQuestions;